import { Injectable } from '@angular/core';
import { UserDataService } from './user-data.service';
import { Membership, MembershipType, Permission } from '../interfaces/payment-interfaces';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  constructor(private userData: UserDataService) { }

  // Map permissions
  private PERMISSIONS: Record<MembershipType, Permission[]> = {
    [MembershipType.TRIAL]: [
      Permission.VIEW_FORECAST,
      Permission.VIEW_DASHBOARD
    ],
    [MembershipType.START]: [],
    [MembershipType.SMART]: [
      Permission.VIEW_FORECAST,
      Permission.VIEW_DASHBOARD
    ],
  };

  hasPlusSubscription(): boolean {
    const user = this.userData.getUser();
    const validTo = user?.membership?.valid_to ? new Date(user.membership.valid_to).getTime() : null;
    const dateNow = Date.now();

    return validTo !== null && validTo > dateNow;
  }

  getSubscriptionType(): MembershipType {
    const user = this.userData.getUser();
    return user?.membership?.membership_type as MembershipType;
  }

  showForecastUpgradeComponents(): boolean {
    const membership = this.userData.getUser()?.membership;
    return membership ? !this.membershipHasPermission(membership, Permission.VIEW_FORECAST) : false;
  }

  membershipHasPermission(membership: Membership, permissions: Permission | Permission[], isActiveCheck = true, requireAll = true): boolean {
    const membershipType = membership.membership_type;

    if (!membershipType) {
      return false;
    }

    const validTo = membership.valid_to ? new Date(membership.valid_to).getTime() : null;
    const dateNow = Date.now();

    if (isActiveCheck && !(validTo !== null && validTo > dateNow)) {
      return false;
    }

    const allowed = this.PERMISSIONS[membershipType] || [];

    if (typeof permissions === 'string') {
      return allowed.includes(permissions);
    }

    if (requireAll) {
      return permissions.every((perm) => allowed.includes(perm));
    } else {
      return permissions.some((perm) => allowed.includes(perm));
    }
  }

}
